import { Address } from '@anyx/shared-utils';

export const BreakDisplay = ({ hasPrevious }: { address: Address; hasPrevious: boolean }) => {
  return hasPrevious ? <div className="w-full" /> : null;
};
